/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Feature_3_TitleInputs */

const en_mk_feature_3_title = /** @type {(inputs: Mk_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams & notifications`)
};

const id_mk_feature_3_title = /** @type {(inputs: Mk_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim & notifikasi`)
};

/**
* | output |
* | --- |
* | "Teams & notifications" |
*
* @param {Mk_Feature_3_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_feature_3_title = /** @type {((inputs?: Mk_Feature_3_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Feature_3_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_feature_3_title(inputs)
	return en_mk_feature_3_title(inputs)
});